import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/options-profit',
  component: () => import('../../routes/OptionsProfit.svelte'),
  card: {
    id: 'options-profit',
    title: 'Options Profit Calculator',
    description: 'Calculate P/L for calls, puts, and multi-leg strategies like spreads, straddles, and iron condors with a visual P/L diagram.',
    icon: 'candlestick_chart',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/options-profit',
    category: 'Savings & Investing',
  },
  seo: {
    title: 'Options Profit Calculator – P/L for Calls, Puts & Spreads',
    description: 'Free options profit calculator. Calculate profit and loss for calls, puts, and multi-leg strategies like bull call spreads, bear put spreads, straddles, and iron condors. Visualize your P/L diagram with break-even prices and max profit/loss.',
  },
};

export default meta;
